/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import "./metered-story-indicator.m.css";
import { CustomLink } from "../../custom-link";
import get from "lodash/get";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { SvgHandler } from "../../svg-handler/svg-handler";
import closeIcon from "../../../../assets/icons/social/close.svg";

class MeteredStoryIndicatorBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: true
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.meteringCount !== prevProps.meteringCount) {
      this.showForm();
    }
  }

  showForm = () => {
    this.setState({ showForm: true });
  };

  hideForm = event => {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ showForm: false });
  };

  openLogin = event => {
    event.preventDefault();
    event.stopPropagation();
    this.props.openLoginTemplate();
  };

  render() {
    if (!this.state.showForm || !this.props.showMeteringIndicator || this.props.meteringCount <= 0) return null;

    return (
      <div>
        <div data-testid="metered-wrapper" styleName="metered-wrapper">
          <p data-testid="metered-desc" styleName="metered-desc">
            You have {this.props.meteringCount} more free stories left. Subscribe us to continue unlimited access to all
            our stories.
          </p>
          <div styleName="btn-wrapper">
            <div data-testid="metered-subscribe-btn" styleName="subscribe-btn">
              <CustomLink href={"/subscription"}>Subscribe</CustomLink>
            </div>
            {!this.props.member && (
              <span data-testid="metered-login" styleName="info-text">
                Already a user? <a onClick={this.openLogin}>Login</a>
              </span>
            )}
          </div>
          <div data-testid="metered-close" onClick={this.hideForm}>
            <SvgHandler width="24" height="24" xlinkHref={closeIcon} />
          </div>
        </div>
      </div>
    );
  }
}

MeteredStoryIndicatorBase.propTypes = {
  meteringCount: PropTypes.number,
  member: PropTypes.object,
  openLoginTemplate: PropTypes.func,
  showMeteringIndicator: PropTypes.bool
};

const mapStateToProps = state => ({
  meteringCount: get(state, ["meteringCount"]),
  member: get(state, ["member"], null),
  showMeteringIndicator: get(state, ["showMeteringIndicator"])
});

const mapDispatchToProps = dispatch => ({
  openLoginTemplate: () => dispatch({ type: "OPEN_LOGIN_TEMPLATE" })
});

export const MeteredStoryIndicator = connect(
  mapStateToProps,
  mapDispatchToProps
)(MeteredStoryIndicatorBase);
